/**
 * More Than Just Gear: poster video on load; full video loads after play tap (lazy src).
 */
(function () {
  'use strict';

  function ensureMainLoaded(main) {
    var url = main.dataset.mainSrc;
    if (!url || main.dataset.mainLoaded === 'true') return Promise.resolve();

    main.removeAttribute('data-main-src');
    main.dataset.mainLoaded = 'true';
    main.src = url;

    return new Promise(function (resolve, reject) {
      main.addEventListener(
        'canplay',
        function () {
          resolve();
        },
        { once: true }
      );
      main.addEventListener(
        'error',
        function () {
          reject(new Error('main video load failed'));
        },
        { once: true }
      );
      main.load();
    });
  }

  function markPosterReady(container, poster) {
    if (!container || !poster) return;
    if (poster.readyState >= 2) {
      container.classList.add('poster-loaded');
      return;
    }
    poster.addEventListener(
      'canplay',
      function () {
        container.classList.add('poster-loaded');
      },
      { once: true }
    );
    poster.addEventListener(
      'error',
      function () {
        container.classList.add('poster-loaded');
      },
      { once: true }
    );
  }

  function syncMute(container, poster, main) {
    var volumeEl = container.querySelector('.video-volume-control');
    if (!volumeEl) return;
    var uiMuted = volumeEl.classList.contains('active');
    var dualLayout = container.dataset.videoLayout === 'dual';

    if (poster) {
      poster.muted = dualLayout ? true : uiMuted;
    }
    if (main) {
      main.muted = uiMuted;
    }
  }

  function onPlayControlClick(container, poster, main, playCtrl) {
    var volCtrl = container.querySelector('.video-volume-control');

    if (!poster && main) {
      syncMute(container, poster, main);
      if (main.paused) {
        main.play().catch(function () {});
        playCtrl.classList.add('active');
      } else {
        main.pause();
        playCtrl.classList.remove('active');
      }
      return;
    }

    if (!poster) return;

    if (!main) {
      if (poster.paused) {
        poster.play().catch(function () {});
        playCtrl.classList.add('active');
      } else {
        poster.pause();
        playCtrl.classList.remove('active');
      }
      syncMute(container, poster, main);
      return;
    }

    var showMain = !container.classList.contains('active');

    if (showMain) {
      ensureMainLoaded(main)
        .then(function () {
          container.classList.add('active');
          playCtrl.classList.add('active');
          poster.pause();
          syncMute(container, poster, main);
          main.play().catch(function () {});
        })
        .catch(function () {
          container.classList.remove('active');
          playCtrl.classList.remove('active');
        });
    } else {
      container.classList.remove('active');
      playCtrl.classList.remove('active');
      main.pause();
      poster.currentTime = 0;
      poster.play().catch(function () {});
      syncMute(container, poster, main);
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var container = e.target.closest('.more-than-just-gear .video-container');
      if (!container) return;

      var poster = container.querySelector('.poster-video');
      var main = container.querySelector('.main-video');
      var playCtrl = container.querySelector('.video-control');
      var volCtrl = container.querySelector('.video-volume-control');

      markPosterReady(container, poster);

      if (volCtrl && e.target.closest('.video-volume-control') === volCtrl) {
        if (!poster && !main) return;
        volCtrl.classList.toggle('active');
        syncMute(container, poster, main);
        return;
      }

      if (!playCtrl || e.target.closest('.video-control') !== playCtrl) return;

      onPlayControlClick(container, poster, main, playCtrl);
    },
    false
  );

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var target = e.target;
      if (!target || !target.closest) return;

      var container = target.closest('.more-than-just-gear .video-container');
      if (!container) return;

      var volBtn = target.closest('.video-volume-control');
      var playBtn = target.closest('.video-control');
      if (!volBtn && !playBtn) return;

      var poster = container.querySelector('.poster-video');
      var main = container.querySelector('.main-video');
      var playCtrl = container.querySelector('.video-control');
      var volumeControl = container.querySelector('.video-volume-control');

      markPosterReady(container, poster);

      if (e.key === ' ') e.preventDefault();

      if (volBtn) {
        if (!poster && !main) return;
        volumeControl.classList.toggle('active');
        syncMute(container, poster, main);
        return;
      }

      onPlayControlClick(container, poster, main, playCtrl);
    },
    false
  );

  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('.more-than-just-gear .video-container')
      .forEach(function (container) {
        var poster = container.querySelector('.poster-video');
        markPosterReady(container, poster);
        if (poster) {
          poster.addEventListener('playing', function () {
            container.classList.add('poster-loaded');
          });
        }
      });
  });
})();
